import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import citiesReducer from "./slices/citiesSlice";
import profileReducer from "./slices/profileSlice";
import quoteFormReducer from "./slices/quoteFormSlice";
import carDataReducer from "./slices/carDataSlice";
import shortlistReducer from "./slices/shortlistSlice";
import storage from "./storage";

// Root Reducer
const rootReducer = combineReducers({
  cities: citiesReducer,
  profile: profileReducer,
  quoteForm: quoteFormReducer,
  carData: carDataReducer,
  shortlist: shortlistReducer,
});

// Persistence Configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["profile", "cities", "carData"],
};

// Create Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Store Factory Function (Important for client-side singleton)
export const makeStore = () => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
    devTools: process.env.NODE_ENV !== "production",
  });
};

// Types
export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
